import fetchMock from "fetch-mock";

// get token
fetchMock.post("end:bearer-token", (url, req) => ({
  status: 200,
  body: {
    message: "security token",
    success: true
  }
}));

// check token
fetchMock.get("end:hello", (url, req) => ({
  status: 200,
  body:
    localStorage.getItem("token") || sessionStorage.getItem("token")
      ? {
          message: "Hello User",
          success: true
        }
      : {
          message: "Hello Stranger",
          success: false
        }
}));

// register new user
fetchMock.post("end:users", (url, req) => ({
  message: "2c822796-e3f5-471e-aedb-f97d7c3308f9",
  success: true
}));

// reset password
fetchMock.post("end:password-reset", (url, req) => ({
  message: "A reset email will be sent",
  success: true
}));
